import { FormModel } from "../../../components/Form";

export const UserFilter = (strings: any): FormModel[] => {
  return [
    {
      label: 'First Name',
      value: "",
      size: "medium",
      autoFocus: true,
      type: "text",
      typeValue: "text",
      variant: "outlined",
      placeholder: "",
      field: "firstName",
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },
    {
      label: 'Last Name',
      value: "",
      size: "medium",
      type: "text",
      typeValue: "text",
      variant: "outlined",
      placeholder: "",
      field: "lastName",
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },
    {
      label: 'Phone no',
      value: "",
      size: "medium",
      type: "text",
      typeValue: "text",
      variant: "outlined",
      placeholder: "",
      field: "phone",
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },
    {
      label: 'Email Id',
      value: "",
      size: "medium",
      type: "text",
      typeValue: "text",
      variant: "outlined",
      placeholder: "",
      field: "email",
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },

  ];
};
